import React from "react"
import {
  Card,
  Col,
  Container,
  Row,
  CardBody,
  Label,
  Button,
  Form,
  Input,
  FormFeedback,
  ButtonGroup,
} from "reactstrap"
import * as Yup from "yup"
import { useFormik } from "formik"
import { useSelector, useDispatch } from "react-redux"
import { useParams } from "react-router-dom"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { ToastContainer, toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"

import { editPackaging, updatePackaging } from "../../../store/actions"

import { useEffect, useState } from "react"

const EditPackaging = props => {
  const dispatch = useDispatch()
  document.title = "Edit packaging"
  const { id } = useParams()

  const [details, setDetails] = useState({})

  useEffect(() => {
    dispatch(editPackaging(id))
  }, [dispatch])

  const packagings = useSelector(state => state.packaging)

  useEffect(() => {
    let packag = []
    if (packagings && packagings.packaging && packagings.packaging.length > 0) {
      packag = packagings.packaging.filter(
        packaging => packaging.packaging_id == id
      )
    }
    if (packag.length > 0) {
      setDetails(packag[0])
    } else {
      props.history.push("/dropdown/packaging/list")
    }
  }, [])

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      packaging_id: details && details.packaging_id ? details.packaging_id : "",

      packaging: details && details.packaging ? details.packaging : "",

      is_default: details && details.is_default ? 1 : 0,
    },
    validationSchema: Yup.object({
      packaging: Yup.string().required("Please enter packaging"),
    }),
    onSubmit: values => {
      values.packaging_id = id // colli_id is from api thats why this needs to be same with "id"
      dispatch(updatePackaging(values, props.history))
    },
  })

  const { error } = useSelector(state => ({
    error: state.packaging.error,
  }))

  useEffect(() => {
    if (error) {
      toast.dismiss()
      toast.error(error, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        progress: undefined,
      })
    }
  }, [error])

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs breadcrumbItem="Edit Packaging" />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  {error ? <ToastContainer /> : ""}
                  <Form
                    id="editpckForm"
                    onSubmit={e => {
                      e.preventDefault()
                      validation.handleSubmit()
                      return false
                    }}
                  >
                    <Row>
                      <Col md={6}>
                        <div className="mb-3 mt-1">
                          <Label htmlFor="pck">Packaging</Label>
                          <Input
                            name="packaging"
                            type="text"
                            id="pck"
                            autoComplete="off"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.packaging || ""}
                          />
                          {validation.touched.packaging &&
                          validation.errors.packaging ? (
                            <FormFeedback type="invalid">
                              {validation.errors.packaging}
                            </FormFeedback>
                          ) : null}
                        </div>
                      </Col>
                    </Row>
                    <div>
                      <h6>Default : </h6>
                      <ButtonGroup>
                        <Button
                          name="is_default"
                          color="success"
                          outline
                          value={1}
                          active={validation.values.is_default == 1}
                          onClick={validation.handleChange}
                        >
                          Yes
                        </Button>

                        <Button
                          name="is_default"
                          color="secondary"
                          outline
                          value={0}
                          active={validation.values.is_default == 0}
                          onClick={validation.handleChange}
                        >
                          No
                        </Button>
                      </ButtonGroup>
                    </div>
                    <br />
                    <div>
                      {packagings && packagings.loading ? (
                        <button
                          type="submit"
                          className="btn btn-primary w-md"
                          disabled
                        >
                          Updating ...
                        </button>
                      ) : (
                        <button type="submit" className="btn btn-primary w-md">
                          Update
                        </button>
                      )}
                    </div>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
        {/* container-fluid */}
      </div>
    </React.Fragment>
  )
}

export default EditPackaging
